import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import FacebookPreview from './Previews/Facebook'
import InstagramPreview from './Previews/Instagram'
import ReelsPreview from './Previews/Reels'
import useIsFirstRender from 'hooks/useFirstRender'
import { generateAdPreviews } from 'utils/helpers'

const AdSuggestions = ({ adSuggestionsRegular = [], adSuggestionsReels = [] }) => {
    const [adSuggestions, setAdSuggestions] = useState([])
    const [adPreviews, setAdPreviews] = useState([])
    const isFirstRender = useIsFirstRender()

    useEffect(() => {
        setAdPreviews(prevAdPreviews => {
            if(!isFirstRender)
                return prevAdPreviews

            let [generatedRegular, generatedReels] = generateAdPreviews(adSuggestionsRegular, adSuggestionsReels)
            const combinedArray = [...generatedRegular]

            // Insert elements from the "reels" array after every 3 elements in the "regular" array
            for (let i = 0; i < generatedReels.length; i++) {
                const insertionIndex = ((i + 1) * 3) + i // Calculate the insertion index
                combinedArray.splice(insertionIndex, 0, generatedReels[i])
            }

            return combinedArray
        })

    }, [adSuggestionsRegular, adSuggestionsReels, isFirstRender])

    useEffect(() => {
        setAdSuggestions(prevAdSuggestions => {
            if(prevAdSuggestions.length) {
                let [generatedRegular, generatedReels] = generateAdPreviews(adSuggestionsRegular, adSuggestionsReels)
                const combinedArray = [...generatedRegular, ...generatedReels]
    
                return prevAdSuggestions.map(ad => {
                    return combinedArray.find(el => (el.id === ad.id && el.type === ad.type))
                })
            }
            return adPreviews ?? []
        })
    }, [adPreviews, adSuggestionsRegular, adSuggestionsReels])

    const displayAds = () => {
        if(adSuggestions.length){
            return adSuggestions.map((page, index) => {
                return <div key={index} className='d-flex flex-column justify-content-between gap-3 mb-4'>
                    {page.type === 'facebook_web' && <div>
                        <div className='suggestion-card-header'>Facebook feed desktop</div>
                        <div className='suggestion-card'>
                            <div className='suggestion-card__web'>
                                <FacebookPreview data={page.data} />
                            </div>
                        </div>
                    </div>}
                    {page.type === 'facebook_mobile' && <div>
                        <div className='suggestion-card-header'>Facebook feed mobile</div>
                        <div className='suggestion-card'>
                            <div className='suggestion-card__mobile'>
                                <FacebookPreview data={page.data} mobileView={true} />
                            </div>
                        </div>
                    </div>}
                    {page.type === 'instagram' && <div>
                        <div className='suggestion-card-header'>Instagram feed mobile</div>
                        <div className='suggestion-card'>
                            <div className='suggestion-card__mobile'>
                                <InstagramPreview data={page.data} />
                            </div>
                        </div>
                    </div>}
                   
                    {page.type === 'reel' && <div>
                        <div className='suggestion-card-header'>Instagram reels</div>
                        <div className='suggestion-card'>
                            <div className='suggestion-card__mobile'>
                                <ReelsPreview data={page.data} />
                            </div>
                        </div>
                    </div>}
                    {/* <div ref={lastAdRef}></div> */}
                </div>
            })}
            
        return null
    }

    return <div className='p-0'>
        {displayAds()}
    </div>
}

AdSuggestions.propTypes = {
    adSuggestionsRegular: PropTypes.arrayOf(Object),
    adSuggestionsReels: PropTypes.arrayOf(Object),
}

export default AdSuggestions